export default "__VITE_ASSET__BvHL9jiV__"